import { createContext } from 'react';

export interface TokenContextValue {
   accessToken: string | undefined;
   isLoading: boolean;
   refreshToken: () => Promise<boolean>;
}

export const TokenContext = createContext<TokenContextValue>({
   accessToken: undefined,
   isLoading: false,
   refreshToken: async () => {
     // no-op
     return true;
   }
});
